var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@material-ui/core/Box/Box';
import Button from '@material-ui/core/Button/Button';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useReducer, useState } from 'react';
import getText from '../../nl-lib/i18n/language';
const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});
export default function ProgressDialog(props) {
    const { progress: propsProgress, open: propsOpen, title, cancelCallback } = props, rest = __rest(props, ["progress", "open", "title", "cancelCallback"]);
    const classes = useStyles();
    const [progress, setProgress] = useState(props.progress);
    const [open, setOpen] = useState(props.open);
    const handleClose = (e) => {
        setOpen(false);
        if (props.cancelCallback) {
            props.cancelCallback(e);
        }
    };
    // const forceUpdate = useForceUpdate();
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    useEffect(() => {
        setProgress(props.progress);
        forceUpdate();
        // forceUpdate();
    }, [props.progress]);
    useEffect(() => {
        setOpen(propsOpen);
    }, [propsOpen]);
    const percent = Math.ceil(progress);
    const buffered = Math.ceil(progress / 10) * 10;
    useEffect(() => {
        // console.log(`dlg progress >> ${progress}, percent=${percent}, buffered=${buffered}`)
    }, [progress]);
    return (_jsxs(Dialog, Object.assign({ open: open }, rest, { onClose: handleClose }, { children: [_jsx(DialogTitle, Object.assign({ id: "form-dialog-title", style: { float: "left", width: "500px" } }, { children: _jsx(Box, Object.assign({ fontSize: 20, fontWeight: "fontWeightBold" }, { children: props.title })) })), _jsxs(DialogContent, { children: [_jsx("div", Object.assign({ className: classes.root }, { children: _jsx(LinearProgress, { variant: "buffer", value: percent, valueBuffer: buffered }) })), _jsx("div", Object.assign({ className: classes.root }, { children: _jsxs(Box, Object.assign({ fontSize: 16, fontWeight: "fontWeightRegular" }, { children: [getText("print_processing"), " ", percent, "%"] })) }))] }), _jsx(DialogActions, { children: _jsx(Button, Object.assign({ onClick: handleClose, color: "primary" }, { children: getText("print_processing_cancel") })) })] })));
}
//# sourceMappingURL=ProgressDialog.js.map